import gql from 'graphql-tag';

export const videoQuery = gql`
  query Videos($search: String!, $offset: Int!, $limit: Int!, $saved: Boolean) {
    videos(search: $search, offset: $offset, limit: $limit, saved: $saved) {
      videos {
        id
        videoType
        videoTitle
        videoUrl
        thumbUrl
        saved
        published
        createdAt
        usedCount
      }
      totalCount
    }
  }
`;

export const uploadVideoDoneQuery = gql`
  query UploadVideoDone($videoId: String!) {
    uploadVideoDone(videoId: $videoId) {
      videoUrl
    }
  }
`;
